export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-sidebar-minimizer/index.ts